<script lang="ts">
	import { locale } from '$lib/localization/locale';
	import { message } from '$lib/localization/messages';
	type BrowserName = 'chrome' | 'firefox' | 'safari' | 'other';
	type OperatingSystem = 'linux' | 'ios' | 'android' | 'macos' | 'windows' | 'other';

	let {
		title,
		description,
		showSetupInstructions = true
	}: {
		title?: string;
		description?: string;
		showSetupInstructions?: boolean;
	} = $props();

	let instructionsVisible: boolean = $state(false);

	function detectBrowser(): BrowserName {
		const ua = navigator.userAgent.toLowerCase();
		if (ua.includes('firefox')) return 'firefox';
		if (ua.includes('safari') && !ua.includes('chrome')) return 'safari';
		if (ua.includes('chrome') || ua.includes('chromium')) return 'chrome';
		return 'other';
	}

	function detectOS(): OperatingSystem {
		const ua = navigator.userAgent;
		if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
		if (/Android/i.test(ua)) return 'android';
		if (/Linux/i.test(ua)) return 'linux';
		if (/Mac/i.test(ua)) return 'macos';
		if (/Win/i.test(ua)) return 'windows';
		return 'other';
	}
</script>

<div
	class="rounded border border-zinc-200 bg-white/85 p-4 text-sm shadow-md backdrop-blur-sm dark:border-zinc-700 dark:bg-zinc-800/85"
>
	<div class="font-semibold text-zinc-800 dark:text-zinc-100">
		{title ?? message($locale, 'editor-help/WebGpuWarning', 'title')}
	</div>
	<div class="mt-1 text-zinc-600 dark:text-zinc-400">
		{description ?? message($locale, 'editor-help/WebGpuWarning', 'description')}
	</div>
	{#if showSetupInstructions}
		<button
			type="button"
			onclick={() => (instructionsVisible = !instructionsVisible)}
			class="mt-3 text-xs font-medium text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-200"
		>
			{message($locale, 'editor-help/WebGpuWarning', instructionsVisible ? 'hide' : 'show')}
			<i class="fa-solid fa-chevron-{instructionsVisible ? 'up' : 'down'} ml-1 text-[10px]"></i>
		</button>
		{#if instructionsVisible}
			{@const browser = detectBrowser()}
			{@const os = detectOS()}
			<div class="mt-3 space-y-2 text-xs text-zinc-500 dark:text-zinc-400">
				{#if os === 'ios'}
					<p>{message($locale, 'editor-help/WebGpuWarning', 'setup0')}</p>
				{:else if browser === 'safari'}
					<p>{message($locale, 'editor-help/WebGpuWarning', 'setup1')}</p>
				{:else if browser === 'firefox'}
					<p>{message($locale, 'editor-help/WebGpuWarning', 'setup2')}</p>
				{:else if os === 'linux'}
					<p>{message($locale, 'editor-help/WebGpuWarning', 'setup3')}</p>
				{:else}
					<p>{message($locale, 'editor-help/WebGpuWarning', 'setup4')}</p>
				{/if}
			</div>
		{/if}
	{/if}
</div>
